import axios from "../request";


//用户提交预约 其他服务
export const addReservation = (data) => axios({
    method:"post",
    url:"/api/v1/user_reservation/add_reservation",
    data:data
});
export const selectBlogClassList = () =>
    axios.get("/api/blogClass/v1/list");
export const selectBlogContentList = (classId) =>
    axios.get("/api/blogContent/v1/list/"+classId);
// 用户提交预约 nacos 服务
// export const addReservation = (data) => axios({
//     method:"post",
//     url:"/website-server/api/v1/user_reservation/add_reservation",
//     data:data
// })

//新增/修改用户点击记录
export const adupVideoClick = (data) => axios({
    method:"post",
    url:"/api/v1/videoVideo/save",
    data:data
});